import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLORS } from 'apps/web_forms/utils/constants';
import clsx from 'clsx';

const StyledButton = styled.button`
  display: flex;
  align-self: flex-start;
  align-items: center;
  justify-content: center;
  margin: 1em 2em;
  border: 2px solid ${(props) => props.mainColor};
  background-color: transparent;
  color: ${(props) => props.mainColor};
  box-sizing: border-box;
  border-radius: 2.5em;
  min-width: 120px;
  padding: 0.5em 1.4em;
  margin-left: 1em;
  font-weight: bold;
  font-family: 'Helvetica', 'Roboto';
  font-size: 13px;
  &:disabled {
    cursor: default !important;
    background: ${COLORS.disabledInputBackgroundColor};
    border: ${COLORS.disabledInputBackgroundColor};
  }
  &.filled-button {
    color: white;
    background-color: ${(props) => props.mainColor};
    &:hover {
      background-color: ${`${(props) => props.mainColor}de`};
      border-color: ${`${(props) => props.mainColor}de`};
    }
  }
  &.material-text {
    color: ${(props) => props.mainColor};
    border-color: rgb(0,0,0,0);
    &:hover {
      background-color: hsla(0, 0%, 50%, 0.1); /* TODO: mix pure grey with arbitrary text color at this opacity */
    }
  }

  svg {
    width: 1em;
    max-height: 1.5em;
    margin-right: 0.75em;
  }

  span {
    text-decoration: none;
  }
`;

// Standardized Device Magic button
const DMButton = ({
  iconComponent: IconComponent,
  filled,
  materialText,
  disabled,
  children,
  type,
  callbackMethod,
  id,
  mainColor,
  className: passedClassName,
}) => {
  return (
    <StyledButton
      id={id}
      onClick={callbackMethod}
      type={type}
      className={clsx(passedClassName, filled && 'filled-button', materialText && 'material-text')}
      disabled={disabled}
      mainColor={mainColor}
    >
      {IconComponent && <IconComponent />}
      {children}
    </StyledButton>
  );
};

DMButton.propTypes = {
  id: PropTypes.string, // TODO: make required
  className: PropTypes.string,
  iconComponent: PropTypes.elementType,
  filled: PropTypes.bool,
  materialText: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.string,
  type: PropTypes.string,
  callbackMethod: PropTypes.func,
  mainColor: PropTypes.string,
};

DMButton.defaultProps = {
  id: undefined,
  className: undefined,
  iconComponent: null,
  filled: false,
  materialText: false,
  disabled: false,
  children: '',
  type: 'button',
  callbackMethod: () => {},
  mainColor: COLORS.primary,
};

export default DMButton;
